// パフォーマンス測定ユーティリティ
export class PerformanceMonitor {
  constructor() {
    this.measurements = {};
    this.apiCalls = [];
    this.enabled = process.env.NODE_ENV === "development";
  }

  // 計測開始
  startTimer(name) {
    if (!this.enabled) return;
    // console.timeと重複しないよう独自のタイマーのみ使用
    this.measurements[name] = {
      start: performance.now(),
      name,
    };
  }

  // 計測終了
  endTimer(name) {
    if (!this.enabled) return;
    if (this.measurements[name]) {
      const duration = performance.now() - this.measurements[name].start;
      this.measurements[name].duration = duration;

      // 結果を表示
      console.log(`⏱️  ${name}: ${duration.toFixed(2)}ms`);

      // 5秒以上の遅延を警告
      if (duration > 5000) {
        console.warn(`⚠️  ${name} が ${duration.toFixed(2)}ms かかりました`);
      }
    }
  }

  // API呼び出し記録
  recordApiCall(apiName, startTime, endTime) {
    if (!this.enabled) return;

    const duration = endTime - startTime;
    this.apiCalls.push({
      name: apiName,
      duration,
      timestamp: new Date().toISOString(),
    });

    // 3秒以上のAPI呼び出しを警告
    if (duration > 3000) {
      console.warn(
        `🐌 API ${apiName} が ${duration.toFixed(2)}ms かかりました`
      );
    }
  }

  // 統計情報を表示
  showStats() {
    if (!this.enabled) return;

    console.group("📊 パフォーマンス統計");

    // 計測結果
    console.log("🕐 計測結果:");
    Object.values(this.measurements).forEach((measurement) => {
      if (measurement.duration) {
        console.log(
          `  ${measurement.name}: ${measurement.duration.toFixed(2)}ms`
        );
      }
    });

    // API呼び出し統計
    if (this.apiCalls.length > 0) {
      console.log("🌐 API呼び出し統計:");
      const avgDuration =
        this.apiCalls.reduce((sum, call) => sum + call.duration, 0) /
        this.apiCalls.length;
      console.log(`  平均応答時間: ${avgDuration.toFixed(2)}ms`);
      console.log(
        `  最大応答時間: ${Math.max(
          ...this.apiCalls.map((c) => c.duration)
        ).toFixed(2)}ms`
      );
      console.log(`  呼び出し回数: ${this.apiCalls.length}`);
    }

    console.groupEnd();
  }

  // 遅延シミュレーション（テスト用）
  simulateDelay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // メモリ使用量チェック
  checkMemoryUsage() {
    if (!this.enabled || !performance.memory) return;

    const memory = performance.memory;
    console.log("💾 メモリ使用量:", {
      used: `${(memory.usedJSHeapSize / 1024 / 1024).toFixed(2)} MB`,
      total: `${(memory.totalJSHeapSize / 1024 / 1024).toFixed(2)} MB`,
      limit: `${(memory.jsHeapSizeLimit / 1024 / 1024).toFixed(2)} MB`,
    });
  }
}

// グローバルインスタンス
export const performanceMonitor = new PerformanceMonitor();

// Vue.jsプラグインとして使用（Vue 3対応）
export default {
  install(app) {
    // Vue 3のプラグインAPIに対応
    app.config.globalProperties.$performance = performanceMonitor;
  },
};
